import styled from 'styled-components';
import { Form } from '../../styled';
export const Steps = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px 24px;

  ${Form} & {
    margin: 24px 0;
  }

  ${({ theme }) => theme.media.down(768)} {
    width: 100%;
    justify-content: space-around;
  }

  ${({ theme }) => theme.media.down(theme.breakpoints.xsmall)} {
    flex-wrap: nowrap;
  }
`;

export const Step = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  ${({ theme }) => theme.media.down(768)} {
    flex-direction: column;
    align-items: center;
  }
`;

export const StepOrder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  background: #47b972;
  font-size: 16px;
  line-height: 24px;
  min-width: 28px;
  height: 28px;
  font-weight: 700;
  border-radius: 100%;

  ${({ theme }) => theme.media.down(theme.breakpoints.xsmall)} {
    justify-content: center;
  }
`;

export const StepLabel = styled.div`
  display: flex;
  color: #242424;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;

  ${({ theme }) => theme.media.down(theme.breakpoints.xsmall)} {
    justify-content: center;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
  }
`;
